import { connect } from 'react-redux';
import ProjectSelect from '../../components/navigation/ProjectSelect';
import { getLocation, getTenantId, getTenants } from '../../reducers/analyticsApp';

const mapStateToProps = (state) => ({
  tenantId: getTenantId(state),
  tenants: getTenants(state),
  location: getLocation(state),
});

export default connect(mapStateToProps)(ProjectSelect);
